<template>

  <b-card body-class="p-0" header-class="border-0">
    <template v-slot:header>
      <b-row align-v="center">
        <b-col>
          <h3 class="mb-0">Moet vandaag leeg</h3>
        </b-col>
<!--        <b-col class="text-right">-->
<!--          <a href="#!" class="btn btn-sm btn-primary">See all</a>-->
<!--        </b-col>-->
      </b-row>
    </template>

    <div class="container float-left" style="max-width:100%;">
      <div v-if="orders.length === 0">
        Yey, alle bestellingen voor vandaag zijn verzonden!
      </div>
      <div v-else class="row" :key="i" v-for="i in Math.ceil(orders.length / 6)">
        <div class="col-lg-2" :key="order.order_number" v-for="order in orders.slice((i - 1) * 6, i * 6)">
          <button type="button" class="btn-icon-clipboard" :style="[order.products.length === 0 ? {'background-color': 'rgba(45,206,137,0.28)'} : '']">
            <div>
              <i class="ni ni-box-2"></i>
              <span>{{ order.order_number }}</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </b-card>
</template>
<script>
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui'
  import {mapGetters} from "vuex";
  export default {
    name: 'order-numbers-table',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
    },
    data() {
      return {
      }
    },
    computed: {
      ...mapGetters({
        orders: 'orders/orders',
        date: 'orders/date',
        futureTotals: 'orders/futureTotals'
      })
    },
    methods: {
    }
  }
</script>
<style>
</style>
